module.exports = __webpack_public_path__ + "static/media/Services-Inactive.465638fe.svg";